import { Container } from '@tribeplatform/react-ui-kit/Layout'

import { CaptchaSettings } from './CaptchaSettings.js'
import { EmbedSettings } from './EmbedSettings.js'
import { PasswordStrength } from './PasswordStrength.js'
import { PrivacySettings } from './PrivacySettings.js'

export const Security = () => {
  return (
    <div>
      <Container size="md">
        <PasswordStrength />
        <CaptchaSettings />
        <EmbedSettings />
        <PrivacySettings />
      </Container>
    </div>
  )
}
